import { useFileUploadContext } from "@/contexts/FileUploadContext";
import { hasIncompleteAttachments } from "@/utils/attachmentUtils";

/**
 * Custom hook to check if user actions should be disabled due to incomplete attachments
 */
export const useAttachmentBlocker = () => {
  const { state } = useFileUploadContext();

  const hasIncompleteFiles = hasIncompleteAttachments(state.attachments);

  return {
    hasIncompleteAttachments: hasIncompleteFiles,
    attachments: state.attachments,
    attachmentCount: state.attachments.length,
  };
};
